import React from 'react';

import serializeJsonLd from './jsonld-serialize';

const SITE_URL = 'https://polypane.app';

/**
 * BreadcrumbList structured data. Google still renders these as a breadcrumb trail in place of the
 * raw URL, which is one of the few enhancements left that a non-news, non-ecommerce site can earn.
 *
 * `items` is ordered root-first, e.g.
 *   [{ name: 'Home', url: '/' }, { name: 'Documentation', url: '/docs/' }, { name: post.title, url: slug }]
 * where each `url` is a site-absolute path with a trailing slash, matching the slugs from gatsby-node.
 */
export default ({ items }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: serializeJsonLd({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          item: `${SITE_URL}${item.url}`,
        })),
      }),
    }}
  />
);
